import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: document.documentElement.getAttribute('lang') || 'en',
    supportedLngs: ['en', 'ka'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      cache: false, // Disable caching to prevent stale translations
      requestOptions: {
        cache: 'no-cache', // Additional cache prevention
      },
    },
    react: {
      useSuspense: false, // Prevent suspense issues on mobile
    },
    // Additional options for better reliability
    load: 'languageOnly', // Only load language, not language-region
    cleanCode: true, // Clean language codes
    nonExplicitSupportedLngs: true, // Support non-explicit language codes
  });

export default i18n;
